jQuery(function ($) {

  const $list = $('.js-list-field');

  /* DRAG REORDER */
  if ($.fn.sortable) {
    $list.sortable({
      handle: '.drag-handle',
      update() {
        console.log('New order:', $list.sortable('toArray', { attribute: 'data-id' }));
      }
    });
  }

  /* SWIPE */
  let startX = 0;

  $list.on('touchstart', '.list-field__row', function (e) {
    startX = e.originalEvent.touches[0].clientX;
  });

  $list.on('touchend', '.list-field__row', function (e) {
    const endX = e.originalEvent.changedTouches[0].clientX;
    if (startX - endX > 60) $(this).addClass('is-swiped');
    if (endX - startX > 60) $(this).removeClass('is-swiped');
  });

  /* INLINE EDIT */
  $list.on('blur', '.js-inline-edit', function () {
    const value = $(this).text();
    const field = $(this).data('field');
    const id = $(this).closest('.list-field__row').data('id');

    console.log('Save', { id, field, value });
    // AJAX save hook
  });

});
